import { BaseApiClient } from './core';
import type { BenchmarkRequest, ContactFormRequest, ContactFormResponse, EmailValidationResponse, LeadMagnetResponse, MarketingLeadRequest, MarketingLeadResponse, PlaybookRequest, QuizResultResponse, QuizSubmissionRequest } from '@/types/marketing';

export class MarketingApiClient extends BaseApiClient {
  // Marketing
  async submitMarketingLead(payload: MarketingLeadRequest): Promise<MarketingLeadResponse> {
    const { data } = await this.client.post<MarketingLeadResponse>('/marketing/leads', payload);
    return data;
  }
  // Contact Form
  async submitContactForm(payload: ContactFormRequest): Promise<ContactFormResponse> {
    const { data } = await this.client.post<ContactFormResponse>('/contact', payload);
    return data;
  }
  // Lead Magnets
  async submitQuiz(payload: QuizSubmissionRequest): Promise<QuizResultResponse> {
    const { data } = await this.client.post<QuizResultResponse>('/lead-magnets/quiz', payload);
    return data;
  }
  async requestPlaybook(payload: PlaybookRequest): Promise<LeadMagnetResponse> {
    const { data } = await this.client.post<LeadMagnetResponse>('/lead-magnets/playbook', payload);
    return data;
  }
  async requestBenchmark(payload: BenchmarkRequest): Promise<LeadMagnetResponse> {
    const { data } = await this.client.post<LeadMagnetResponse>('/lead-magnets/benchmark', payload);
    return data;
  }
  async validateEmail(email: string): Promise<EmailValidationResponse> {
    const { data } = await this.client.post<EmailValidationResponse>('/lead-magnets/validate-email', { email });
    return data;
  }
}

export const marketingApi = new MarketingApiClient();
